import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { ButtonSize } from 'constants/button';
import { ExternalLinkButton } from 'ui-components/common/ExternalLinkButton';

export const EventRidiUsage = () => (
  <StylesContainer>
    <StylesTitle>리디포인트 쿠폰 사용 방법</StylesTitle>
    <StylesOrders>
      <StylesOrder>❶ 이벤트 미션을 완료해요.</StylesOrder>
      <StylesOrder>❷ 혜택 받기를 눌러요.</StylesOrder>
      <StylesOrder>❸ 쿠폰 코드를 복사해요.</StylesOrder>
      <StylesOrder>❹ 리디 쿠폰 등록 페이지에서 등록해요.</StylesOrder>
    </StylesOrders>
    <StylesExternalLinkButton
      href="https://ridibooks.com/coupon/"
      size={ButtonSize.Large}
      buttonTypography={Typography.XSmall}
      label="쿠폰 등록하러 리디 가기"
    />
  </StylesContainer>
);

const StylesContainer = styled.section`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StylesTitle = styled.p`
  font-weight: ${FontWeight.Bold};
  ${Typography.Medium}
`;

const StylesOrders = styled.div`
  margin-top: 8px;
`;

const StylesOrder = styled.p`
  ${Typography.XSmall}
  color: ${Color.Gray600};
`;

const StylesExternalLinkButton = styled(ExternalLinkButton)`
  width: 100%;
  margin-top: 24px;

  & > button {
    width: 100%;
  }
`;
